module.exports = __webpack_public_path__ + "img/img3.b70f393a.png";